const SSO_RETRY_MESSAGE =
  "Sign-in didn't complete — please try again. If this keeps happening, make sure you're not in a private/incognito tab.";

export const RETRYABLE_GOOGLE_ERROR_CODES: ReadonlySet<string> = new Set([
  'Configuration',
  'OAuthCallback',
  'Callback',
  'OAuthSignin',
  'Verification',
]);

export const GOOGLE_ERROR_MESSAGES: Record<string, string> = {
  google_not_enrolled:
    "We couldn't find a Norhi account for that Google email. Ask your teacher to enrol you first.",
  google_profile_incomplete:
    'Google did not share enough of your profile to sign you in. Please try again.',
  Configuration: SSO_RETRY_MESSAGE,
  OAuthCallback: SSO_RETRY_MESSAGE,
  Callback: SSO_RETRY_MESSAGE,
  OAuthSignin: SSO_RETRY_MESSAGE,
  Verification: SSO_RETRY_MESSAGE,
};

export function getLoginErrorMessage(code: string | null | undefined): string {
  if (!code) return '';
  return GOOGLE_ERROR_MESSAGES[code] ?? code;
}

export function isRetryableGoogleError(code: string | null | undefined): boolean {
  if (!code) return false;
  return RETRYABLE_GOOGLE_ERROR_CODES.has(code);
}
